"use client"

import { Analytics } from '@vercel/analytics/react';
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from '@/components/ui/tooltip';
import { AOSInit } from '@/components/aos-init';
import Chatbot from '@/components/chatbot';

export function RootProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AOSInit />
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <TooltipProvider>
          {children}
          <Toaster />
          {process.env.NEXT_PUBLIC_VERCEL_ENV === "production" && <Analytics />}
        </TooltipProvider>
      </ThemeProvider>
      <Chatbot />
    </>
  );
}
